"use client";

import deskTopImage from "@root/src/assets/images/category/banner_category_1.png";
import tabLetImage from "@root/src/assets/images/category/banner_category_2.png";
import mobileImage from "@root/src/assets/images/category/banner_category_3.png";
import ResponsiveBanner from "@components/themes/lytra/common/ResponsiveBanner";

interface HeroBannerBottomCategoryProps {
  collection: {
    name: string;
    description?: string;
    image?: string[] | string;
  };
}

export default function HeroBannerBottomCategory({ collection }: HeroBannerBottomCategoryProps) {
  return (
    <ResponsiveBanner
      alt={collection.name}
      desktopSrc={deskTopImage}
      tabletSrc={tabLetImage}
      mobileSrc={mobileImage}
      sizes="100vw"
      backgroundColor="#f5eee0"
    />
  );
}
